import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";
import { t } from "@/lib/localization";

export type GetStoragePathResponseType = InferResponseType<
    typeof client.api.storage.query.path.$get,
    200
>;

export const useGetStoragePath = ({ path }: { path?: string }) => {
    const query = useQuery({
        queryKey: ["get-storage-path", { path }],
        queryFn: async () => {
            if (!path || path === "/") {
                return [];
            }

            const response = await client.api.storage.query.path.$get({
                query: {
                    path,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch storage path");
            }

            const { folders } = await response.json();

            return folders;
        },
    });

    return query;
};
